import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateSmokerRateStatusByFilter } from '../../../api/plan-smoker-rate-override-rules-api'
import type { PlanSmokerRateOverrideRuleStatus } from '../enums/plan-smoker-rate-override-rule.enum'
import type {
  UpdateSmokerRateStatusByFilterQueryDto,
  UpdateSmokerRateStatusByFilterResponseDto,
} from '../../../api/dto/plan-smoker-rate-override-rules.dto'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'

interface Variables {
  query: UpdateSmokerRateStatusByFilterQueryDto
  targetStatus: PlanSmokerRateOverrideRuleStatus
}

export function useUpdateSmokerRateStatusByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    UpdateSmokerRateStatusByFilterResponseDto,
    unknown,
    Variables
  >({
    mutationFn: ({ query, targetStatus }) =>
      updateSmokerRateStatusByFilter(query, { status: targetStatus }),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
    },
  })
}
